import(/* webpackMode: "eager", webpackExports: ["UploadProvider"] */ "/app/app/_context/UploadContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnimatePresence"] */ "/app/node_modules/framer-motion/dist/es/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/app/node_modules/next-auth/react.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Montserrat\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"700\"],\"display\":\"swap\"}],\"variableName\":\"montserrat\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Nunito_Sans\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"700\"],\"display\":\"swap\"}],\"variableName\":\"nunitoSans\"}");
;
import(/* webpackMode: "eager" */ "/app/app/globals.css");
